var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.251,
    height: 14.25,
    viewBox: "0 0 14.251 14.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".filled{fill:#a7a5a5;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 9.117)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "filled",
    d: "M11.488,307.954l-2.167-.728a.5.5,0,0,0-.161-.027H5.089a.5.5,0,0,0-.161.027l-2.167.728A4.066,4.066,0,0,0,0,311.819a.511.511,0,0,0,.509.513H13.742a.511.511,0,0,0,.509-.513A4.066,4.066,0,0,0,11.488,307.954Z",
    transform: "translate(0 -307.199)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.045)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "filled",
    d: "M139.613,0a3.08,3.08,0,0,0-3.08,3.08V5.133a3.08,3.08,0,0,0,6.16,0V3.08A3.08,3.08,0,0,0,139.613,0Z",
    transform: "translate(-136.533)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserFilled);
export default __webpack_public_path__ + "static/media/user-filled.f6cbbd832b6e16f3ac6ba01037d61029.svg";
export { ForwardRef as ReactComponent };